// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { fromJS } from 'immutable'

const initialState = fromJS({
  comments: [],
  dbSet: '',
  entityId: null,
  error: '',
  initialValues: {},
  isNewEntity: true,
  sourceForm: null,
})

export default initialState
